// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1iCyI","alert":"SettungsInbox_alert__3U38R"};